module.exports = __webpack_public_path__ + "static/media/gexankar2.8f597f25.jpg";